import React from "react";
import { Field } from "formik";

const OptionCheckbox = ({ fieldName, label }) => (
  <div className="checkbox">
    <Field name={fieldName} id={fieldName}>
      {({ field: { value }, form: { setFieldValue } }) => (
        <label>
          <input type="checkbox" checked={value} value={value} onChange={() => setFieldValue(fieldName, !value)} />
          {label}
        </label>
      )}
    </Field>
  </div>
);

export default OptionCheckbox;
